/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type HpRespTopHeroBannerModule_homepage = {
    readonly topHeroBannerModule: {
        readonly title?: string | null;
        readonly items?: ReadonlyArray<{
            readonly cmsId: number | null;
            readonly imageUrl?: string | null;
            readonly mobileImageUrl?: string | null;
            readonly linkData: {
                readonly path: string | null;
            };
            readonly imageCopy: string | null;
            readonly cta: string | null;
        } | null> | null;
    } | null;
    readonly " $refType": "HpRespTopHeroBannerModule_homepage";
};
export type HpRespTopHeroBannerModule_homepage$data = HpRespTopHeroBannerModule_homepage;
export type HpRespTopHeroBannerModule_homepage$key = {
    readonly " $data"?: HpRespTopHeroBannerModule_homepage$data;
    readonly " $fragmentRefs": FragmentRefs<"HpRespTopHeroBannerModule_homepage">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "HpRespTopHeroBannerModule_homepage",
  "type": "Homepage",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isMobile",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": "topHeroBannerModule",
      "name": "module",
      "storageKey": "module(type:\"topHeroBanner\")",
      "args": [
        {
          "kind": "Literal",
          "name": "type",
          "value": "topHeroBanner"
        }
      ],
      "concreteType": null,
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "type": "TopHeroBannerModule",
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "title",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "items",
              "storageKey": null,
              "args": null,
              "concreteType": "TopHeroBannerItem",
              "plural": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "cmsId",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "linkData",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "LinkData",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "path",
                      "args": null,
                      "storageKey": null
                    }
                  ]
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "imageCopy",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "cta",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "Condition",
                  "passingValue": false,
                  "condition": "isMobile",
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "imageUrl",
                      "args": null,
                      "storageKey": null
                    }
                  ]
                },
                {
                  "kind": "Condition",
                  "passingValue": true,
                  "condition": "isMobile",
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "mobileImageUrl",
                      "args": null,
                      "storageKey": null
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = 'c64afd3a62ec7cfe9fbb3c67b317748a';
export default node;
